// Sibling button group for /order_packages?school_id=N. Mounted next to the
// school dropdown and the Add-Yearbook-Sale button so the page header is one
// row of controls instead of three stacked rows.
//
// Re-uses generateYearbookCSV and the TotalsPerStudentModal trigger that
// previously lived inline in the Yearbooks component.
import React from 'react'
import PropTypes from 'prop-types'
import { generateYearbookCSV, TotalsPerStudentModal } from '../Yearbooks/Yearbooks'

const YearbookHeaderActions = ({ onlineOrders = [], currentUser, school }) => (
  <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
    <button
      className="btn"
      type="button"
      onClick={() => generateYearbookCSV(onlineOrders, currentUser?.admin, school)}
    >
      Generate CSV
    </button>
    <TotalsPerStudentModal onlineOrders={onlineOrders} school={school} />
  </div>
)

YearbookHeaderActions.propTypes = {
  onlineOrders: PropTypes.array,
  currentUser: PropTypes.object.isRequired,
  school: PropTypes.object.isRequired,
}

export default YearbookHeaderActions
